import React from 'react';

import { StyledButton } from './Button.styles';
import { TButtonProps } from './Button.types';

const Button = ({ type = 'button', children, ...props }: TButtonProps) => (
  <StyledButton type={type} {...props}>
    {children}
  </StyledButton>
);

export default Button;
